<template>
    <div class="treports-pages">
        <PageTitle icon="mdi-chart-gantt" main="TReports"
            sub="Cadastros & Cia" />
                    
        <div class="treports-pages-tabs">
            <v-tabs
            background-color="indigo"
            slider-color="indigo lighten-5"
            v-model="tabActived"
            grow
            center-active
            dark
            icons-and-text
            >
                <v-tab
                    v-for="n in nav.length"
                    :key="n"
                    ripple
                    class="ma-0"
                    >
                    {{ nav[n-1].title }}
                    <v-icon>{{ nav[n-1].icon }}</v-icon>
                </v-tab>
                
                <v-tab-item
                    v-for="n in nav.length"
                    :key="n">
                    <v-card flat>
                        <v-card-text>
                            <keep-alive>
                                <Register 
                                    :title="nav[n-1].title"
                                    :scope="nav[n-1].scope"
                                    :path="nav[n-1].path"
                                    :segment="nav[n-1].segment"
                                    :query="nav[n-1].query"
                                    :arrayChilds="nav[n-1].arrayChilds"
                                    :minorScopes="nav[n-1].minorScopes"
                                    :componentHeader="nav[n-1].componentHeader"
                                    :disableNewItem="nav[n-1].disableNewItem"
                                    :enableImport="nav[n-1].enableImport"
                                    :headers="nav[n-1].headers"
                                    :subHeaders="nav[n-1].subHeaders"
                                    :expand="nav[n-1].expand"
                                    :maxWidthForm="nav[n-1].maxWidthForm"
                                    :maxWidthFormImport="nav[n-1].maxWidthFormImport"
                                    :itemModel="nav[n-1].itemModel"
                                    :inputs="nav[n-1].inputs"
                                    :inputsImport="nav[n-1].inputsImport"
                                    :optionExportPdf="nav[n-1].optionExportPdf"
                                />
                            </keep-alive>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Register from '../register/Default'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('treports')

export default {
    name: 'TReportsPages',
    components: { PageTitle, Register },
    data: function() {
        return {
            nav: [
                /* Users */
                {
                    title: 'TReports',
                    icon: "mdi-file-alert",
                    path: 'researches/treports',
                    query: 'limit=500',
                    scope: 'treports',
                    optionExportPdf: {
                        landscape: true,
                        columns: [
                            { header: 'Email', dataKey: 'email' },
                            { header: 'Profissão', dataKey: 'profession' },
                            { header: 'Você já tentou montar relatórios pra Protheus em ADVPL, SigaRPM ou qualquer outra ferramenta?', dataKey: 'question1' },
                            { header: 'Qual foi a sua maior dificuldade pra conseguir fazer os relatórios?', dataKey: 'question2' },
                            { header: 'Se você pudesse fazer um teinamento de TReports, o que não poderia faltar nesse treinamento?', dataKey: 'question3' },
                            { header: 'Se vc pudesse fazer qualquer pergunta sobre confecção de relatórios pra Protheus com o TReports, o que você perguntaria?', dataKey: 'question4' }
                        ]
                    },
                    headers: [
                        { text: 'ID', value: '_id', options: { copy: true, slice: -6, toUpperCase: true } },
                        { text: 'Email', value: 'email', options: {} },
                        { text: 'Profissão', value: 'profession', options: {} },
                        { 
                            text: 'Ações', 
                            value: 'actions', 
                            sortable: false, 
                            align: 'center', 
                            options: { 
                                edit: false,
                                delete: false,
                                tdClass: 'text-center', 
                            } 
                        }
                    ],
                    maxWidthForm: 50,
                    inputs: [
                        { 
                            vType: 'v-text-field', 
                            label: 'Email', 
                            vModel: 'email', 
                            required: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-text-field', 
                            label: 'Profissão', 
                            vModel: 'profession', 
                            required: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-textarea', 
                            label: 'Você já tentou montar relatórios pra Protheus em ADVPL, SigaRPM ou qualquer outra ferramenta?', 
                            vModel: 'question1', 
                            required: true,
                            dense: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-textarea', 
                            label: 'Qual foi a sua maior dificuldade pra conseguir fazer os relatórios?', 
                            vModel: 'question2', 
                            required: true,
                            dense: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-textarea', 
                            label: 'Se você pudesse fazer um teinamento de TReports, o que não poderia faltar nesse treinamento?', 
                            vModel: 'question3', 
                            required: true,
                            dense: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-textarea', 
                            label: 'Se vc pudesse fazer qualquer pergunta sobre confecção de relatórios pra Protheus com o TReports, o que você perguntaria?', 
                            vModel: 'question4', 
                            required: true,
                            dense: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['tabActived']),
        
        tabActived: {
			get () {
				return this.$store.state.registers.tabActived
			},
			set (value) {
				this.$store.commit('registers/setTabActived', value)
			}
		},
    },
}
</script>

<style>

</style>